import { Card, CardBorderRadius, CardBorderStyle, CardHeaderTheme, CardTheme } from '@apply/components';
import { Broker } from '../../queries/brokerQueries';
import { BrokerAddress } from './components/BrokerAddress';
import { BrokerContact } from './components/BrokerContact';
import { hasBrokerAddress } from './functions/hasBrokerAddress';
import '../../styles/_detailCard.scss';

/** The selected broker's name (in the header), with its address on the left and contact details on the right. */
export const BrokerCard = ({ broker }: { broker: Broker }) => {
    return (
        <Card
            header={<b>{broker.displayName}</b>}
            headerTheme={CardHeaderTheme.Blue}
            theme={CardTheme.White}
            borderStyle={CardBorderStyle.Solid}
            borderRadius={CardBorderRadius.Small}
            width='100%'
        >
            <div className='brokerSelectorCardColumns'>
                {/* Left out when there's no address, so the contact details move into the left column */}
                {hasBrokerAddress(broker) && (
                    <div>
                        <BrokerAddress broker={broker} />
                    </div>
                )}
                <div className='brokerSelectorCardSections'>
                    <BrokerContact broker={broker} />
                </div>
            </div>
        </Card>
    );
};
